import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={11}
    fill="currentColor"
    viewBox="0 0 11 11"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.498 8.1a.48.48 0 0 0 .348-.14.47.47 0 0 0 .142-.348V5.337a.47.47 0 0 0-.14-.347.47.47 0 0 0-.344-.14.48.48 0 0 0-.349.14.47.47 0 0 0-.142.347v2.275q0 .208.14.348t.345.14m0-4.225a.48.48 0 0 0 .49-.485.48.48 0 0 0-.484-.49.48.48 0 0 0-.49.485.48.48 0 0 0 .484.49m.007 6.825q-1.074 0-2.022-.406a5.2 5.2 0 0 1-1.659-1.117A5.2 5.2 0 0 1 .707 7.518a5.1 5.1 0 0 1-.406-2.024q0-1.077.406-2.018A5.243 5.243 0 0 1 3.482.706 5.1 5.1 0 0 1 5.508.3q1.076 0 2.018.406a5.26 5.26 0 0 1 2.77 2.773q.406.944.406 2.017 0 1.074-.407 2.022a5.24 5.24 0 0 1-2.772 2.776 5.05 5.05 0 0 1-2.017.406M5.5 9.725q1.76 0 2.992-1.232Q9.726 7.26 9.726 5.5T8.493 2.507Q7.261 1.275 5.501 1.275T2.508 2.507 1.276 5.5t1.232 2.993 2.993 1.232"
    />
  </svg>
);
export default SvgInfo;
